import { render, staticRenderFns } from "./createFunction.vue?vue&type=template&id=6add38d2&scoped=true"
import script from "./createFunction.vue?vue&type=script&lang=js"
export * from "./createFunction.vue?vue&type=script&lang=js"
import style0 from "./createFunction.vue?vue&type=style&index=0&id=6add38d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add38d2",
  null
  
)

export default component.exports